import script from "./PreviewImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PreviewImage.vue?vue&type=script&lang=ts&setup=true"

import "./PreviewImage.vue?vue&type=style&index=0&id=75d9af0f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75d9af0f"]])

export default __exports__